//package imports
import React, { useEffect, useState, useRef } from "react";
import { getPresignedUrl } from "../../services/apiServices/PostServices";
import { ImageUtils } from "../imageUtils/ImageUtils";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import { Controller, useForm } from "react-hook-form";
import Modal from 'react-bootstrap/Modal';
import FileUpload from "./FileUpload";
import Button from 'react-bootstrap/Button';
import CustomModal from "./CustomModal";
import Switch from "@mui/material/Switch";
import { showToast } from "../constants/Toaster";


const MetaDataEditModal = (props) => {
    const { imgvalue, close, open, height, from, Continue, data, edit, onClickUpdate, onClickSave } = props;
    const [value, setValue] = useState("")
    const [previewImg, setPreviewImg] = useState("");
    const [timelineYear, setTimelineYear] = useState("")
    const [show, setShow] = useState(false);
    const [checked, setCheckedValue] = useState(false)
    const [swichChecked, setSwitchChecked] = useState("false")
    const [errorMessage, setErrorMessage] = useState("")

    const [timelineDescription, setTimeLineDescription] = useState("")
    const [title, setTitle] = useState("")
    const [seoDescription, setSeoDescription] = useState("")
    const [keywords, setKeywords] = useState("")
    const [storeName,setStoreName]=useState("")
    const [subHeading,setSubHeading]=useState("")
    const [storeDescription,setStoreDescription]=useState("")
    const [pageName, setPageName] = useState("")

    const modalRef = useRef();

    useEffect(() => {
        if (data !== undefined || data !== "") {
            setValue(data?.value)
            setTimelineYear(data?.year)
            setTimeLineDescription(data?.description)
            setTitle(data?.title)
            setSeoDescription(data?.description)
            setStoreDescription(data?.description)
            setSubHeading(data?.sub_heading)
            setStoreName(data?.name)
            setKeywords(data?.keywords)
            setPageName(data?.url)
            setPreviewImg(data?.value)
            setSwitchChecked(edit)
            setErrorMessage("")
            if (data?.value === "1") {
                setCheckedValue(true)
            } else {
                setCheckedValue(false)
            }
        }
    }, [data]);


    const handleClose = () => {
        setShow(false)
    };

    const handleCloseModal = () => {
        setValue(data?.value)
        setTimelineYear(data?.year)
        setTimeLineDescription(data?.description)
        setSubHeading(data?.sub_heading)
        setTitle(data?.title)
        setStoreName(data?.name)
        setSeoDescription(data?.description)
        setStoreDescription(data?.description)
        setKeywords(data?.keywords)
        setPageName(data?.url)
        setPreviewImg(data?.value)
        setErrorMessage("")
        if (data?.value === "1" && checked === false) {
            setCheckedValue(true)
        } else if (data?.value === "0" && checked === true) {
            setCheckedValue(false)
        }
        close()

    }

    const dynamicValueReqbody = {
        id: data?.id,
        value: value,
        key: data?.key
    }

    const homeDataReqBody = {
        id:data?.id,
        name:storeName,
        sub_heading:subHeading,
        description:storeDescription
    }

    const handleBannerImage = async (data, fileInfo) => {
        let size = fileInfo.fileSize
        if (size > 5 * 1048576) {
            // setErrorMessage("Size should not execed more than 5 mb")
        }
        else if (size < 5 * 1048576) {
            // setErrorMessage("")
            const reqBody = {
                fileName: data?.name,
                mediaType: data?.type,
                dataType: "stores",
                serviceType: "thumbnail-image"
            };

            const resUrl = await getPresignedUrl("dataSignUrl", reqBody)
            if (resUrl?.success) {
                ImageUtils.uploadFileToS3(data, true, resUrl?.data?.preSignedUrl)
                    .then(res => {
                        if (res?.ok) {
                            setValue(resUrl?.data.dataUrl)
                        }
                    })
                    .catch(e => {
                        console.log(e);
                    });
                setPreviewImg(resUrl?.data.dataUrl)
                console.log("res", resUrl?.message)
            } else {
                console.log("res", resUrl?.message)
            }
        }
    }

    const timeLineReqbody = {
        id: data?.id,
        year: timelineYear,
        description: timelineDescription
    }

    const seqEditReqbody = {
        id: data?.id,
        title: title,
        description: seoDescription,
        keywords: keywords
    }

    //function for handle modal backDrop Click
    const handleBackdropClick = (e) => {
        if (modalRef.current && !modalRef.current.contains(e.target)) {
            // Handle the click outside the modal (e.g., prevent closing the modal)
            e.preventDefault();
            e.stopPropagation();
        }
    };

    const handlePreviewImg = (data) => {
        setPreviewImg(data)
        setShow(true)
    }

    const buttonStyle = {
        backgroundColor: "#0A2FB6", // Set your desired background color
        color: 'white', // Set the text color if needed
    };

    const handleOnValue = (e) => {
        let Value = e.target.value;
        if (Value.length === 1 && Value[0] === ' ') {
            // setInputValue(newInputValue);
            setValue("");
        } else {
            setValue(Value)
        }
    };

    const handleOnChangeYear = (e) => {
        let Value = e.target.value;
        if (Value.length === 1 && Value[0] === ' ') {
            // setInputValue(newInputValue);
            setTimelineYear("");
        } else {
            setTimelineYear(Value)
        }
    }

    const handleDescription = (e) => {
        let Value = e.target.value;
        if (Value.length === 1 && Value[0] === ' ') {
            // setInputValue(newInputValue);
            setTimeLineDescription("");
        } else {
            setTimeLineDescription(Value)
        }
    }

    const handleStoreDescription = (e) => {
        let Value = e.target.value;
        if (Value.length === 1 && Value[0] === ' ') {
            // setInputValue(newInputValue);
            setStoreDescription("");
        } else {
            setStoreDescription(Value)
        }
    }

    const handleOnChangeTitle = (e) => {
        let Value = e.target.value;
        if (Value.length === 1 && Value[0] === ' ') {
            // setInputValue(newInputValue);
            setTitle("");
        } else {
            setTitle(Value)
        }
    }

    const handleOnChangeStoreName = (e) => {
        let Value = e.target.value;
        if (Value.length === 1 && Value[0] === ' ') {
            // setInputValue(newInputValue);
            setStoreName("");
        } else {
            setStoreName(Value)
        }
    }

    const handleOnChangeSubHeading = (e) => {
        let Value = e.target.value;
        if (Value.length === 1 && Value[0] === ' ') {
            // setInputValue(newInputValue);
            setSubHeading("");
        } else {
            setSubHeading(Value)
        }
    }

    const handleSeoDescription = (e) => {
        let Value = e.target.value;
        if (Value.length === 1 && Value[0] === ' ') {
            setSeoDescription("");
        } else {
            setSeoDescription(Value)
        }
    }

    const handleKeywords = (e) => {
        let Value = e.target.value;
        if (Value.length === 1 && Value[0] === ' ') {
            setKeywords("");
        } else {
            setKeywords(Value)
        }
    }


    const onClickUpdateButton = () => {
        if (from === "seo") {
            if (title === "" || seoDescription === "" || keywords === "") {
                setErrorMessage("Please enter the above empty fields")
            } else if (title !== "" || seoDescription !== "" || keywords !== "") {
                onClickSave(seqEditReqbody)
            }
        } else {
            if (value === "" && from === "dynamicData") {
                setErrorMessage("Please enter the value")
            }else if (storeName === "" && from === "homeData") {
                setErrorMessage("Please enter the name")
            }else if (subHeading === "" && from === "homeData") {
                setErrorMessage("Please enter the above sub heading")
            }else if (storeDescription === "" && from === "homeData") {
                setErrorMessage("Please enter the description")
            }
            else if (from === "timeLine" && (timelineYear === "" || timelineDescription === "" )) {
                setErrorMessage("Please enter the above required values")
            } else {
                onClickUpdate(from === "dynamicData" ? dynamicValueReqbody : from === "timeLine" ? timeLineReqbody :homeDataReqBody)
            }
        }

    }

    const handleSwitch = (e) => {

        if (e === true) {
            setValue("1")
            setCheckedValue(true)
        } else {
            setValue("0")
            setCheckedValue(false)
            setSwitchChecked("false")
        }

    }

    return (
        <Modal show={open} onHide={handleCloseModal} aria-labelledby="contained-modal-title-vcenter"
            centered size={from === "SupportModal" ? "lg" : "md"} backdrop="static" onClick={imgvalue != undefined ? null : handleBackdropClick}  >
            <Modal.Header style={{ backgroundColor: "#0A2FB6", color: "white" }} data-bs-theme="dark" closeButton>
                <h6 class="text-white fw-bold m-0 montserrat">Edit</h6>
            </Modal.Header>
            {
                data.type === 4 ?
                    <div style={{ height: `${height}`, borderRadius: "24px" }}>
                        <Modal.Body class="text-center p-4">
                            <div>
                                <h6 class="text-start m-0">Key</h6>
                                {/* <h6>{data?.key}</h6> */}
                                <input class="form-control form-control-lg" type="text" name="Value" placeholder="Value" value={data?.key} aria-label="default input example"></input>
                            </div>
                            <h6 class="text-start m-0 mt-2">{"Value"}</h6>

                            <ReactQuill theme="snow" value={value} onChange={setValue} />
                        </Modal.Body>
                        <Modal.Footer class="d-flex justify-content-center align-self-center">

                            <Button className="px-2 py-2 my-2" onClick={onClickUpdateButton} style={buttonStyle}>
                                Save
                            </Button>
                        </Modal.Footer>
                    </div>
                    :
                    <div style={{ height: `${height}`, borderRadius: "24px" }} class="mt-2">
                        <Modal.Body class="text-center p-4">
                            {
                                from === "dynamicData" ?
                                    <>
                                        <div>
                                            <div>
                                                <h6 class="text-start m-0">Key</h6>
                                                {/* <h6>{data?.key}</h6> */}
                                                <input class="form-control form-control-lg" type="text" name="Value" placeholder="Value" value={data?.key} aria-label="default input example"></input>
                                            </div>
                                            <h6 class="text-start m-0 mt-2">{data.type === 1 ? "Value" : data.type === 2 ? "Upload" : "Status"}</h6>

                                            {
                                                data?.type === 3 ?
                                                    <Switch
                                                        value={checked}
                                                        onClick={(e) => {
                                                            handleSwitch(e?.target?.checked)
                                                        }}
                                                        checked={checked}
                                                    /> :
                                                    <div class="" >
                                                        <input class="form-control form-control-lg" type="text" name="Value" placeholder="Value" value={value} aria-label="default input example" onChange={(e) => { handleOnValue(e) }}></input>

                                                    </div>
                                            }

                                        </div>

                                    </> :
                                    from === "timeLine" ?
                                        <>
                                            <h6 class="text-start">Description</h6>
                                            <div class="mb-4" >
                                                <textarea class="form-control form-control-lg" name="description" id="exampleFormControlTextarea1" placeholder="Description" rows="5" value={timelineDescription}
                                                    onChange={(e) => { handleDescription(e) }}></textarea>
                                            </div>
                                            <h6 class="text-start">Year</h6>
                                            <input class="form-control form-control-lg" type="text" name="Year" placeholder="Year" value={timelineYear} aria-label="default input example" onChange={(e) => { handleOnChangeYear(e) }}></input>
                                        </>:
                                         from === "homeData" ?
                                         <>
                                          <div className="mb-2">
                                                <h6 class="text-start m-0">Name</h6>
                                                {/* <h6>{data?.key}</h6> */}
                                                <input class="form-control form-control-lg" type="text" name="Value" placeholder="Name" value={storeName} aria-label="default input example" onChange={(e) => { handleOnChangeStoreName(e) }}></input>
                                            </div>
                                            <div className="mb-2">
                                                <h6 class="text-start m-0">Sub heading</h6>
                                                {/* <h6>{data?.key}</h6> */}
                                                <input class="form-control form-control-lg" type="text" name="Value" placeholder="Expected to reache" value={subHeading} aria-label="default input example" onChange={(e) => { handleOnChangeSubHeading(e) }}></input>
                                            </div>
                                         <h6 class="text-start m-0">Description</h6>
                                         <div class="mb-0" >
                                             <textarea class="form-control form-control-lg" name="description" id="exampleFormControlTextarea1" placeholder="Description" rows="5" value={storeDescription}
                                                 onChange={(e) => { handleStoreDescription(e) }}></textarea>
                                         </div>
                                    
                                     </>
                                        :
                                        <>
                                            <h6 class="text-start" >Page name:-  <span class="paraColor fw-normal">{pageName}</span> </h6>
                                            <h6 class="text-start">Title </h6>
                                            <div class="mb-2">
                                                <input class="form-control form-control-lg" type="text" name="Title" placeholder="Title" value={title} aria-label="default input example" onChange={(e) => { handleOnChangeTitle(e) }}></input>
                                            </div>
                                            <h6 class="text-start">Description</h6>
                                            <div class="mb-2" >
                                                <textarea class="form-control form-control-lg" name="Seodescription" id="exampleFormControlTextarea1" placeholder="Description" rows="3" value={seoDescription}
                                                    onChange={(e) => { handleSeoDescription(e) }}></textarea>
                                            </div>
                                            <h6 class="text-start">Key words</h6>
                                            <div class="mb-2" >
                                                <textarea class="form-control form-control-lg" name="Keywords" id="exampleFormControlTextarea1" placeholder="Keywords" rows="4" value={keywords}
                                                    onChange={(e) => { handleKeywords(e) }}></textarea>
                                            </div>
                                        </>
                            }
                            {errorMessage !== "" ? <h6 class="m-0 text-start text-danger">{errorMessage}</h6> : <h6 class="m-0 text-start text-danger" >{errorMessage}</h6>}
                        </Modal.Body>
                        {
                            <Modal.Footer class="d-flex justify-content-center align-self-center">

                                <Button className="px-2 py-2 my-2" onClick={onClickUpdateButton} style={buttonStyle}>
                                    Save
                                </Button>


                                {
                                    data.type === 2 && from === "dynamicData" ?
                                        <div class="d-flex my-2 mx-2">
                                            <FileUpload onClick={handleBannerImage} from={"imgInput1"} id={"preIpo"} name={"preIpoimg1"} />
                                            {
                                                data.type === 2 && previewImg !== "" ?

                                                    <p onClick={() => handlePreviewImg(previewImg)} class="d-flex h-100 colorPrimary m-0 align-items-center justify-content-center cursorPointer mx-2 fs-5" >Preview</p>
                                                    :
                                                    null
                                            }
                                        </div>
                                        :
                                        null
                                }


                            </Modal.Footer>
                        }
                        <CustomModal
                            close={handleClose}
                            open={show}
                            imgvalue={previewImg}
                        />
                    </div>
            }

        </Modal>
    )
}

export default MetaDataEditModal